import React from 'react'
import { WelcomeMessage } from './types'

/**
 * Get welcome messages from rendered React content
 * Both welcome message and secondary welcome message are optional
 * If either is not provided, it will not be displayed
 *
 * @param welcomeMessage - Rendered React node for welcome message
 * @param secondaryWelcomeMessage - Rendered React node for secondary welcome message (shown before example questions)
 * @returns Array of welcome message(s) to display, empty array if none provided
 */
export const getWelcomeMessages = (
  welcomeMessage?: React.ReactNode,
  secondaryWelcomeMessage?: React.ReactNode
): WelcomeMessage[] => {
  const messages: WelcomeMessage[] = []
  let messageId = 1

  // Add primary welcome message if provided
  if (welcomeMessage) {
    messages.push({
      id: String(messageId),
      content: welcomeMessage,
    })
    messageId++
  }

  // Add secondary welcome message if provided
  if (secondaryWelcomeMessage) {
    messages.push({
      id: String(messageId),
      content: secondaryWelcomeMessage,
    })
    messageId++
  }

  return messages
}

/**
 * Extract text from example question entries
 * @param exampleQuestions - Array of text strings from Contentful
 * @returns Array of non-empty question strings
 */
export const extractExampleQuestions = (exampleQuestions?: string[]): string[] => {
  return exampleQuestions?.filter((text) => text?.trim().length > 0) ?? []
}
